import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import theme from './config/theme';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider as UserProvider } from './contexts/UserContext';
ReactDOM.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <UserProvider>
        <CssBaseline />
        <App />
      </UserProvider>
    </ThemeProvider>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
